import _ from 'lodash';
import React, { Fragment, Component } from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';
import Dropzone from 'react-dropzone';

import config from 'client/shared/config';

import HFMModalNeo from '../hfm-modal-neo';
import ImageUpload from '../image-upload';

class ActionComp extends Component {
	render () {
		const {
			item,
			imgData,
			imgSrc = '',
			imgPath,
			onDrop,
			onClick,
			fullWidth,
			imgClassName,
			displayAsButton = true
		} = this.props;

		if (displayAsButton) {

			return (
				<button className="button secondary clear" onClick={ onClick }>
					Edit Image
				</button>
			);
		}

		if (_.isEmpty(imgSrc)) {
			return (
				<Dropzone
					accept="image/*"
					onDrop={ onDrop }
				>
					{
						({getRootProps, getInputProps}) => (
							<section>
								<div
									{
										...getRootProps({
											className: `drop-zone${ fullWidth ? ' full-width' : '' }`
										})
									}
								>
									<input {...getInputProps()} />
									<span className="fas fa-image"></span>
									<br />
									{!fullWidth &&
										(<strong>
											Click here to upload your profile image.
										</strong>)
									}
									{fullWidth &&
										(<strong>
											Click here to upload your banner image.
										</strong>)
									}
								</div>
							</section>
						)
					}
				</Dropzone>
			);
		}

		const styles = {
			// backgroundImage: `url(${ (/^data/).test(imgSrc) ? imgSrc : imgPath })`,
			backgroundImage: `url(${ item.profileImagePath })`,
			width: '16rem',
			height: '16rem',
			backgroundSize: '100% 16rem',
			backgroundPosition: `center`,
			transform: `scale(0.85)`
		};

		const fwStyles = {
			backgroundImage: `url(${ (/^data/).test(imgSrc) ? imgSrc : imgPath })`,
			height: `16rem`,
			transform: `scale(0.85)`,
			backgroundSize: `contain`,
			backgroundPosition: `center`,
		};

		return (
			<div className={ `edit-image ${imgClassName}` } style={ this.props.fullWidth ? fwStyles : styles } onClick={ onClick }></div>
		);
	}
}

class EditImage extends Component {
	state = {
		imgSrc: this.props.imgSrc || this.props.imgData,
		isModalOpen: false
	}

	render () {
		const {
			store,
			item,
			imgData,
			height = 400,
			width = 400,
			aspectRatio = 1,
			buttonText = 'Upload Image',
			fullWidth = false,
			alwaysShowUpload = false,
			displayAsButton = false,
			imgClassName = this.props.mode === 'banner' ? 'image banner preview' : 'image medium',
		} = this.props;

		const { imgSrc = imgData, isModalOpen } = this.state;

		return (
			<div className={`image-wrapper${ fullWidth ? ' full-width' : '' }` }>
				<HFMModalNeo
					isOpen={ isModalOpen }
					contentLabel="Edit Image"
					styles='modal-banner'
				>
					<ImageUpload
						imgSrc={ imgSrc }
						store={ store }
						item={ item }
						height={ height }
						width={ width }
						aspectRatio={ aspectRatio }
						mode={this.props.mode}
						imgClassName={ imgClassName }
						handleImageCrop={ this.handleImageCrop }
					>
						<button
							className="button neo margin-right-1"
							onClick={ this.handleCloseModal }
						>
							Close
						</button>
					</ImageUpload>
				</HFMModalNeo>

				<ActionComp
					item={item}
					fullWidth={this.props.mode === 'banner' ? true : false}
					onDrop={ this.onDrop }
					onClick={ this.handleOpenModal }
					imgClassName={ imgClassName }
					imgPath={ imgSrc }
					buttonText={ buttonText }
					displayAsButton={ displayAsButton }
					imgSrc={ alwaysShowUpload ? '' : imgSrc }
				/>
			</div>
		);
	}

	@autobind
	handleImageCrop (cropResult) {
		const { handleImageCrop = _.noop } = this.props;

		console.log('[handleImageCrop]', cropResult)

		this.setState({
			imgSrc: cropResult
		});

		handleImageCrop(cropResult);

		this.handleCloseModal();
	}

	@autobind
	handleOpenModal () {
		this.setState({
			isModalOpen: true
		});
	}

	@autobind
	handleCloseModal () {
		this.setState({
			isModalOpen: false
		});
	}

	@autobind
	onDrop ([ file ]) {
		const { store, item } = this.props;
		
		if (item) {

			item.uploadFile = file;
		} else {

			store.set({
				key: 'editImage.uploadImage',
				value: file
			});
		}

		this.handleOpenModal();
	}
}

export default EditImage;
